// extracted by mini-css-extract-plugin
export default {"title":"TextItem_title__B4tw8"};